export default {
  SET_SEARCH_HISTORIES(state, data) {
    state.searchHistories = data
  },
  SET_TOTAL_SEARCH_HISTORIES(state, total) {
    state.totalSearchHistories = total
  }
}
